/**
 * Discover / browse sport scope helpers (ADR-030 active sport).
 * Arenas carry sportId; orgs/players are linked via Arena participation.
 */

import { normalizeSportId } from "./sportTypes";

/**
 * @param {object | null | undefined} arena
 * @param {string | null | undefined} sportId
 * @returns {boolean}
 */
export function arenaMatchesSport(arena, sportId) {
  if (!sportId) return true;
  const wanted = normalizeSportId(sportId);
  const actual = normalizeSportId(arena?.sportId || arena?.sport);
  return actual === wanted;
}

/**
 * @param {object[]} arenas
 * @param {string | null | undefined} sportId
 * @returns {Set<string>}
 */
export function collectOrganizationIdsForSport(arenas, sportId) {
  const ids = new Set();
  if (!sportId) return ids;
  (arenas || []).forEach((a) => {
    if (!arenaMatchesSport(a, sportId)) return;
    const oid = String(a?.organizationId || "").trim();
    if (oid) ids.add(oid);
  });
  return ids;
}

/**
 * Player ids registered on arenas for the given sport.
 * @param {object[]} arenas
 * @param {string | null | undefined} sportId
 * @returns {Set<string>}
 */
export function collectPlayerIdsFromArenasForSport(arenas, sportId) {
  const ids = new Set();
  if (!sportId) return ids;
  (arenas || []).forEach((a) => {
    if (!arenaMatchesSport(a, sportId)) return;
    (a.managedEntries || []).forEach((e) => {
      (e.memberPlayerIds || []).forEach((id) => {
        if (id) ids.add(String(id));
      });
      (e.members || []).forEach((m) => {
        if (m?.playerId) ids.add(String(m.playerId));
      });
    });
  });
  return ids;
}
